import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Card.css";

function SixColumnCards() {
  return (
    <Container>
      <Row className="justify-content-center gy-3">
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card ">
            <Card.Img variant="top" src="./img/immagini/1.png" alt="fire" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/pesce.png" alt="pesce" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/fuoco.png" alt="fire" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/tartare.png" alt="tartare" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/5.png" alt="plate" className="card-img" />
          </Card>
        </Col>
        <Col lg={2} md={4} sm={6} xs={12}>
          <Card className="custom-card">
            <Card.Img variant="top" src="./img/immagini/orata.jpg" alt="orata" className="card-img" />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

export default SixColumnCards;
